// app/src/lib/pwa-update.ts
// When a new build is ready, the service worker installs and *waits* (we never
// reload an open till automatically — that could discard an in-progress basket).
// This shows a small, theme-aware banner so the cashier can apply the update the
// moment it's safe. Tapping "Update now" tells the waiting worker to take over and
// reloads onto the new version.

let visible = false;

export function showUpdatePrompt(apply: () => void) {
  if (visible || typeof document === "undefined") return;
  visible = true;

  const bar = document.createElement("div");
  bar.setAttribute("role", "status");
  bar.style.cssText = [
    "position:fixed",
    "left:50%",
    "bottom:max(16px,env(safe-area-inset-bottom))",
    "transform:translateX(-50%)",
    "z-index:99999",
    "display:flex",
    "align-items:center",
    "gap:10px",
    "background:var(--ink,#161310)",
    "color:var(--paper,#ffffff)",
    "padding:11px 12px 11px 18px",
    "border-radius:14px",
    "box-shadow:0 14px 36px rgba(0,0,0,.32)",
    "font:600 14px/1.2 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif",
    "max-width:calc(100vw - 24px)",
  ].join(";");

  const msg = document.createElement("span");
  msg.textContent = "A new version of the till is ready.";

  const update = document.createElement("button");
  update.textContent = "Update now";
  update.style.cssText =
    "background:var(--accent,#BB2D22);color:#fff;border:0;border-radius:10px;padding:9px 14px;font:700 14px system-ui;cursor:pointer;white-space:nowrap;";
  update.onclick = () => {
    update.textContent = "Updating…";
    update.disabled = true;
    later.disabled = true;
    apply();
  };

  const later = document.createElement("button");
  later.textContent = "Later";
  later.setAttribute("aria-label", "Dismiss update notice");
  later.style.cssText =
    "background:transparent;color:var(--paper,#ffffff);opacity:.65;border:0;border-radius:10px;padding:9px 10px;font:600 13px system-ui;cursor:pointer;";
  later.onclick = () => {
    bar.remove();
    visible = false;
  };

  bar.append(msg, update, later);
  document.body.appendChild(bar);
}
